import React, { useState } from 'react';




// material
import { makeStyles } from '@mui/styles';

import {
  Box, Typography,

  Modal,
  FormControl,

  Button,
  TextField,

} from '@mui/material';



import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import PropTypes from 'prop-types';


import { APP_CONSTANTS } from '../../../URLConstants';
import { AddDeviceToMerchant, DeAttachFromMerchant } from '../../../network/ProductionApp';
import AlertDialog from '../../AlertDialog';
import { parseValidationErrorMessage } from '../../../utils/Utilities';






// ----------------------------------------------------------------------





const useStyles = makeStyles({
  customDashCard: {
    background: "#FFFFFF",
    boxShadow: "10px 10px 19px 1px #EAEAFF",
    borderRadius: "20px",
    minHeight: "190px"
  },
});


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 300,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: 1
};

const DeviceSchema = Yup.object().shape({
  deviceId: Yup.string().when('$type', {
    is: APP_CONSTANTS?.ADD_DEVICE_MERCHANT_ACTION,
    then: Yup.string().required('Required'),
    otherwise: Yup.string()
  }),

  merchantQR: Yup.string()
    .required('Required'),

});


export default function ActivateDeviceModal({ opneAssignedModal, handleClose, _onAction, merchantData, type }) {



  const [openAlertDialog, setOpenAlertDialog] = useState(false)
  const [alertDialogMetas, setAlertDialogMetas] = useState({
    message: "",
    title: "",
    btnLabel: "",

  });


  const addDeviceFormik = useFormik({
    initialValues: {
      deviceId: '',
      merchantVPA: ''
    },
    validationSchema: () => {
      if (type === APP_CONSTANTS?.ADD_DEVICE_MERCHANT_ACTION) {
        return Yup.object().shape({
          deviceId: Yup.string().required('Required'),
          merchantVPA: Yup.string().required('Required')
        });
      }
      return Yup.object().shape({
        merchantVPA: Yup.string().required('Required')
      });

    },
    onSubmit: () => {
      if (type === APP_CONSTANTS?.REMOVE_DEVICE_MERCHANT_ACTION)
        removeDevice(merchantData?.device_id, addDeviceFormik?.values?.merchantVPA)
      else
        activateDevice(addDeviceFormik?.values?.deviceId, addDeviceFormik?.values?.merchantVPA)
    }
  });

  const { errors, touched, handleSubmit, getFieldProps } = addDeviceFormik;



  function activateDevice(deviceId, merchantVPA) {
    AddDeviceToMerchant(deviceId, merchantVPA).then((res) => {
      handleClose()
      setAlertDialogMetas({ ...alertDialogMetas, message: "Device has been attached ", title: "Device attached ", btnLabel: "OK" });
      setOpenAlertDialog(true)
      

    }).catch((err) => {
      setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: " ", btnLabel: "OK" });
      setOpenAlertDialog(true)
    })
  }

  function removeDevice(deviceId, merchantVPA) {
    DeAttachFromMerchant(deviceId, merchantVPA).then((res) => {
      handleClose()
      setAlertDialogMetas({ ...alertDialogMetas, message: 'Device has been unmapped !', title: "", btnLabel: "OK" });
      setOpenAlertDialog(true)

    }).catch((err) => {
      setAlertDialogMetas({ ...alertDialogMetas, message: parseValidationErrorMessage(err), title: " ", btnLabel: "OK" });
      setOpenAlertDialog(true)
    })
  }


  return (
    <Box >
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        data-testid='device-act-de-act-modal'
        aria-labelledby="activate-modal-title"
        aria-describedby="activate-modal-description">

        <FormikProvider value={{ ...addDeviceFormik, type }}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={style}>
              <Typography sx={{ fontSize: 18, fontWeight: 900 }}>
                {
                  type === APP_CONSTANTS?.REMOVE_DEVICE_MERCHANT_ACTION ?
                    "De-attach Device"
                    :
                    "Activate Device"
                }
              </Typography>

              {
                type === APP_CONSTANTS?.ADD_DEVICE_MERCHANT_ACTION ?
                  <div>
                    <FormControl fullWidth sx={{ mb: 1, mt: 3 }}>
                      <TextField
                        label="Enter Device Id"
                        id="deviceId"
                        name="deviceId"
                        variant="outlined"
                        {...getFieldProps('deviceId')}
                        error={Boolean(touched.deviceId && errors.deviceId)}
                        helperText={touched.deviceId && errors.deviceId}
                      />
                    </FormControl>
                  </div>
                  :
                  null
              }

              <FormControl fullWidth sx={{ mb: 2, mt: 3 }}>
                <TextField
                  label="Enter Merchant VPA"
                  id="merchantVPA"
                  name="Merchant VPA"
                 
                  variant="outlined"
                  {...getFieldProps('merchantVPA')}
                  error={Boolean(touched.merchantVPA && errors.merchantVPA)}
                  helperText={touched.merchantVPA && errors.merchantVPA}
                />
              </FormControl>

              <Button variant="contained" sx={{ mt: 3 }} type='submit' fullWidth size="large" >
                {
                  type === APP_CONSTANTS?.REMOVE_DEVICE_MERCHANT_ACTION ?
                    "De-attach Device"
                    :
                    "Activate Device"
                }
              </Button>
            </Box>
          </Form>
        </FormikProvider>

      </Modal>


      <AlertDialog openAlertDialog={openAlertDialog} message={alertDialogMetas?.message} title={alertDialogMetas?.title}
        btnLabel={alertDialogMetas?.btnLabel} handleClose={() => setOpenAlertDialog(false)} />

    </Box>
  );
}

ActivateDeviceModal.propTypes = {
  opneAssignedModal: PropTypes.bool,
  handleClose: PropTypes.func,
 _onAction: PropTypes.func,
  merchantData: PropTypes.object,
  type: PropTypes.string
}